var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGivingHeart = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3n-web/art/giving-heart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3n-web/art/giving-heart",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", {
    id: "art/giving-heart2",
    transform: "translate(18, 2.9998)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#1B7690",
    transform: "translate(33.1241, 29.8699) rotate(-90) translate(-33.1241, -29.8699)",
    cx: 33.1241443,
    cy: 29.8698888,
    rx: 29.8698888,
    ry: 29.8758557
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6808797,78.4159218 L7.46507739,77.2273188 C7.46507739,77.2273188 17.5200387,50.3926472 17.2616716,48.0779435 C16.9563288,45.3373768 15.6997255,42.4961708 16.3264257,39.5659785 C17.4079373,34.5181237 19.1289606,34.2998953 22.2795436,35.6940143 C24.1895378,36.5415031 25.8315563,34.336973 26.6386864,36.1866171 C26.9173384,36.8222337 27.7992027,37.4504347 27.6497342,38.1464349 C27.6230434,38.2724988 26.5340584,42.2779425 26.4998942,42.4071845 C26.2628798,43.2822166 25.8763969,44.1328835 25.6521941,45.0174498 C25.0778079,47.2774198 24.5041335,49.5373898 23.9311708,51.7973598",
    id: "Path",
    fill: "#F7BDA4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F6C760",
    points: "12.2181765 63.2045582 21.1905586 65.7851614 23.573514 55.8229313 15.5000783 53.52094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.303403,58.9607584 L18.9026225,57.6492695 L18.9026225,57.6492695 L14.2338664,56.4479542 C14.2338664,56.4479542 0.32048184,85.5888546 0,94.4546462 C-0.00344837728,94.5799789 0.0447755904,94.7013274 0.133646183,94.7904636 L16.6819473,94.7904636 C17.2360485,85.193713 23.303403,58.9607584 23.303403,58.9607584 Z",
    id: "Path",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8328114,42.7122805 C37.9395746,43.6127372 38.1904682,44.513194 38.2790817,45.4189476 C38.507555,47.7375356 38.7356724,50.0571829 38.963434,52.3778896 C39.0701972,53.4308943 42.0307417,78.7178396 42.134302,79.7708444 L51.4227033,79.9583513 C51.4227033,79.9583513 45.5133583,51.936136 46.1219088,49.6849941 C46.8350872,47.0207013 48.5048641,44.3977237 48.3244343,41.4071478 C48.0148209,36.2554756 46.3450439,35.7851194 43.0193692,36.6982885 C41.004747,37.2512749 39.709709,34.8306352 38.6356709,36.5404437 C38.2652025,37.1294484 37.2989952,37.6188731 37.3417005,38.3297043 C37.3438358,38.4621244 37.8189321,42.5830384 37.8328114,42.7122805 Z",
    id: "Path",
    fill: "#F7BDA4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F6C760",
    points: "49.3664434 68.3805957 40.1058006 69.6062763 39.2463566 59.4025119 47.576024 58.3209044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3874246,61.4025853 L43.5905525,61.8994256 L43.5905525,61.8994256 L39.0424388,62.5456357 C39.0424388,62.5456357 40.726095,84.1904982 40.2744865,95.0002171 L57.8509175,95.0002171 C55.71245,80.8916483 48.3874246,61.4025853 48.3874246,61.4025853 Z",
    id: "Path",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.709709,34.7946169 C36.8623336,35.6156216 38.3004343,43.3457783 38.4904729,44.0746186 C39.3445787,47.3586375 42.3916014,46.6817058 44.5097839,46.0259614 C46.6279665,45.370217 47.3571594,39.2460515 45.3115758,38.3254669 C44.6197501,38.0161335 41.8396355,34.1801875 39.709709,34.7946169 Z",
    id: "Path",
    fill: "#DD9987"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(40.89, 64.6856) rotate(16.3) translate(-40.89, -64.6856)",
    points: "40.4614824 64.2598389 41.3204019 64.2580452 41.3186082 65.1113553 40.4596887 65.113149"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(46.5819, 63.3442) rotate(16.29) translate(-46.5819, -63.3442)",
    points: "46.2316324 62.9961694 46.9337063 62.994704 46.9322409 63.6921917 46.2301671 63.6936571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(54.4652, 90.8555) rotate(16.29) translate(-54.4652, -90.8555)",
    points: "54.1148587 90.5074967 54.8169325 90.5060314 54.8154672 91.2035191 54.1133933 91.2049845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(48.4942, 77.6683) rotate(16.3) translate(-48.4942, -77.6683)",
    points: "48.1439126 77.3202905 48.8459859 77.3188243 48.8445198 78.0163126 48.1424464 78.0177787"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.6515, 67.5131) rotate(16.3) translate(-44.6515, -67.5131)",
    points: "44.2623756 67.1264859 45.0423386 67.1248571 45.0407098 67.8997262 44.2607468 67.901355"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(49.2568, 71.6332) rotate(16.3) translate(-49.2568, -71.6332)",
    points: "48.9065217 71.2852221 49.6085951 71.283756 49.6071289 71.9812442 48.9050556 71.9827103"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(42.8351, 71.0617) rotate(16.3) translate(-42.8351, -71.0617)",
    points: "42.4847672 70.7136489 43.1868405 70.7121828 43.1853744 71.409671 42.4833011 71.4111371"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(45.9939, 75.2822) rotate(16.29) translate(-45.9939, -75.2822)",
    points: "45.7212809 75.0113711 46.2675755 75.0102309 46.2664352 75.5529569 45.7201407 75.5540971"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(42.248, 93.0493) rotate(16.29) translate(-42.248, -93.0493)",
    points: "41.9754496 92.7785092 42.5217442 92.777369 42.5206039 93.320095 41.9743094 93.3212352"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(40.8832, 67.7632) rotate(16.2602) translate(-40.8832, -67.7632)",
    points: "40.6105864 67.4923646 41.1568821 67.4912262 41.1557437 68.033951 40.609448 68.0350894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(42.1275, 76.6285) rotate(16.3) translate(-42.1275, -76.6285)",
    points: "41.7383682 76.241893 42.5183311 76.2402642 42.5167023 77.0151334 41.7367394 77.0167622"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(51.3334, 77.3155) rotate(16.29) translate(-51.3334, -77.3155)",
    points: "50.9048364 76.8896974 51.7637565 76.8879047 51.7619638 77.7412141 50.9030436 77.7430068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(47.7941, 93.4652) rotate(16.29) translate(-47.7941, -93.4652)",
    points: "47.3655425 93.0394883 48.2244626 93.0376956 48.2226699 93.8910051 47.3637498 93.8927978"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(43.0598, 89.6867) rotate(16.29) translate(-43.0598, -89.6867)",
    points: "42.6312197 89.2609449 43.4901399 89.2591522 43.4883472 90.1124616 42.629427 90.1142543"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(48.1534, 66.6725) rotate(16.3) translate(-48.1534, -66.6725)",
    points: "47.7248253 66.2467465 48.5837448 66.2449528 48.5819511 67.0982628 47.7230316 67.1000565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(48.1075, 80.5017) rotate(16.3) translate(-48.1075, -80.5017)",
    points: "47.7572239 80.1536542 48.4592972 80.1521881 48.4578311 80.8496763 47.7557577 80.8511424"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(53.8966, 85.1359) rotate(16.3) translate(-53.8966, -85.1359)",
    points: "53.5462976 84.7878546 54.2483709 84.7863885 54.2469048 85.4838767 53.5448314 85.4853428"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(50.4498, 93.0439) rotate(16.3) translate(-50.4498, -93.0439)",
    points: "50.099523 92.6959356 50.8015963 92.6944694 50.8001302 93.3919577 50.0980568 93.3934238"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(50.3738, 85.6407) rotate(16.3) translate(-50.3738, -85.6407)",
    points: "49.9846153 85.2541031 50.7645782 85.2524743 50.7629494 86.0273434 49.9829865 86.0289722"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(53.6977, 88.8989) rotate(16.29) translate(-53.6977, -88.8989)",
    points: "53.347388 88.5509328 54.0494618 88.5494674 54.0479965 89.2469551 53.3459226 89.2484205"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.2659, 82.9005) rotate(16.3) translate(-44.2659, -82.9005)",
    points: "43.954459 82.5910613 44.5786427 82.5897578 44.5773392 83.2098651 43.9531555 83.2111686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.2068, 78.4381) rotate(16.29) translate(-44.2068, -78.4381)",
    points: "43.973074 78.2058922 44.4414789 78.2049146 44.4405012 78.6702597 43.9720963 78.6712374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(41.5209, 81.914) rotate(16.2602) translate(-41.5209, -81.914)",
    points: "41.2871469 81.6818111 41.7555528 81.680835 41.7545768 82.1461792 41.2861709 82.1471552"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(52.267, 81.4268) rotate(16.3) translate(-52.267, -81.4268)",
    points: "52.0332665 81.1946518 52.5016711 81.1936736 52.5006929 81.6590191 52.0322883 81.6599973"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(45.914, 71.2655) rotate(16.29) translate(-45.914, -71.2655)",
    points: "45.6802895 71.0333249 46.1486944 71.0323472 46.1477168 71.4976924 45.6793119 71.49867"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(49.6959, 73.8944) rotate(16.29) translate(-49.6959, -73.8944)",
    points: "49.4622324 73.6621987 49.9306373 73.661221 49.9296596 74.1265662 49.4612547 74.1275438"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(41.6046, 73.1699) rotate(16.3) translate(-41.6046, -73.1699)",
    points: "41.3708451 72.9376726 41.8392497 72.9366944 41.8382715 73.4020399 41.369867 73.4030181"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(41.9582, 86.2206) rotate(16.29) translate(-41.9582, -86.2206)",
    points: "41.5296192 85.7948878 42.3885393 85.793095 42.3867466 86.6464045 41.5278265 86.6481972"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(47.4903, 88.7122) rotate(16.29) translate(-47.4903, -88.7122)",
    points: "47.2177464 88.441367 47.7640409 88.4402268 47.7629007 88.9829528 47.2166062 88.984093"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(53.7725, 93.9784) rotate(16.3) translate(-53.7725, -93.9784)",
    points: "53.4999416 93.707617 54.0462358 93.7064762 54.0450949 94.2492026 53.4988008 94.2503434"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(47.9024, 84.9234) rotate(16.3) translate(-47.9024, -84.9234)",
    points: "47.6686525 84.6912538 48.137057 84.6902756 48.1360788 85.1556211 47.6676743 85.1565993"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(51.2675, 88.9673) rotate(16.3) translate(-51.2675, -88.9673)",
    points: "51.0338311 88.7350869 51.5022357 88.7341087 51.5012575 89.1994542 51.0328529 89.2004323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(44.7942, 88.0521) rotate(16.29) translate(-44.7942, -88.0521)",
    points: "44.5604741 87.8199643 45.028879 87.8189867 45.0279013 88.2843318 44.5594964 88.2853095"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(45.4334, 91.5375) rotate(16.3) translate(-45.4334, -91.5375)",
    points: "45.1996535 91.3052715 45.668058 91.3042933 45.6670798 91.7696388 45.1986753 91.770617"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(45.0331, 85.5438) rotate(16.3) translate(-45.0331, -85.5438)",
    points: "44.6439285 85.1571527 45.4238914 85.1555239 45.4222626 85.930393 44.6422997 85.9320218"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4098416,33.2204065 C28.1013427,34.4524433 25.5166048,41.8838602 25.2219383,42.5766823 C23.8820597,45.6996783 20.9727616,44.577815 18.9762892,43.6159153 C16.9798167,42.6540156 17.179464,36.4853569 19.3403518,35.8825806 C20.0716799,35.6791833 23.3920165,32.2977032 25.4098416,33.2204065 Z",
    id: "Path",
    fill: "#DD9987"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(21.1458, 60.8039) rotate(172.27) translate(-21.1458, -60.8039)",
    points: "20.7156885 60.3769626 21.5750121 60.37785 21.5758995 61.230756 20.716576 61.2298686"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.7375, 58.6358) rotate(172.28) translate(-15.7375, -58.6358)",
    points: "15.3859396 58.2868456 16.0883434 58.2875701 16.0890679 58.9847278 15.3866641 58.9840033"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(3.8141, 84.6764) rotate(172.28) translate(-3.8141, -84.6764)",
    points: "3.46249937 84.3274509 4.16490323 84.3281754 4.16562772 85.0253331 3.46322386 85.0246086"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.6869, 72.5132) rotate(172.28) translate(-11.6869, -72.5132)",
    points: "11.3353194 72.1642617 12.0377233 72.1649862 12.0384477 72.8621439 11.3360439 72.8614194"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(17.007, 63.0398) rotate(172.28) translate(-17.007, -63.0398)",
    points: "16.616439 62.6521304 17.3967691 62.6529353 17.3975739 63.4274372 16.6172438 63.4266323"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.8319, 66.4353) rotate(172.27) translate(-11.8319, -66.4353)",
    points: "11.4803079 66.0863942 12.1827116 66.0871196 12.183437 66.7842776 11.4810333 66.7835522"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(18.2663, 66.82) rotate(172.27) translate(-18.2663, -66.82)",
    points: "17.9147328 66.4710525 18.6171364 66.4717779 18.6178618 67.1689359 17.9154582 67.1682105"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(14.5158, 70.5317) rotate(172.27) translate(-14.5158, -70.5317)",
    points: "14.2422193 70.2601711 14.7887705 70.2607355 14.7893349 70.8032049 14.2427838 70.8026405"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.5629, 88.6528) rotate(172.28) translate(-15.5629, -88.6528)",
    points: "15.2893888 88.3813024 15.8359401 88.3818661 15.8365039 88.9243354 15.2899525 88.9237716"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(20.7388, 63.8688) rotate(172.27) translate(-20.7388, -63.8688)",
    points: "20.4652812 63.5972969 21.0118324 63.5978613 21.0123968 64.1403307 20.4658457 64.1397663"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(18.1367, 72.4267) rotate(172.28) translate(-18.1367, -72.4267)",
    points: "17.7461029 72.03903 18.526433 72.0398349 18.5272379 72.8143368 17.7469078 72.813532"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(9.2611, 71.7778) rotate(172.5191) translate(-9.2611, -71.7778)",
    points: "8.83168419 71.3516115 9.68972538 71.3524697 9.69058362 72.2040878 8.83254242 72.2032296"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(10.0159, 88.2417) rotate(172.28) translate(-10.0159, -88.2417)",
    points: "9.58576549 87.8148275 10.4450894 87.8157138 10.4459757 88.6686195 9.58665183 88.6677331"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.266, 85.204) rotate(172.28) translate(-15.266, -85.204)",
    points: "14.8359133 84.7771466 15.6952372 84.7780329 15.6961235 85.6309386 14.8367996 85.6300523"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(13.6714, 61.6898) rotate(172.28) translate(-13.6714, -61.6898)",
    points: "13.2412773 61.2629168 14.1006012 61.2638032 14.1014875 62.1167089 13.2421636 62.1158225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.6334, 75.3754) rotate(172.27) translate(-11.6334, -75.3754)",
    points: "11.2818506 75.0264265 11.9842542 75.0271519 11.9849796 75.7243099 11.282576 75.7235845"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(8.8712, 85.4319) rotate(172.27) translate(-8.8712, -85.4319)",
    points: "8.51962056 85.0829622 9.22202417 85.0836876 9.22274957 85.7808455 8.52034597 85.7801201"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(4.087, 92.7948) rotate(172.28) translate(-4.087, -92.7948)",
    points: "3.73542632 92.4458197 4.43783019 92.4465441 4.43855467 93.1437018 3.73615081 93.1429774"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.4808, 77.6704) rotate(172.28) translate(-6.4808, -77.6704)",
    points: "6.01173495 77.2048409 6.94898508 77.2058076 6.9499518 78.1360576 6.01270166 78.1350908"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(8.6304, 80.1181) rotate(172.28) translate(-8.6304, -80.1181)",
    points: "8.23979143 79.7304664 9.02012155 79.7312713 9.02092641 80.5057732 8.24059629 80.5049684"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(4.8656, 82.8539) rotate(172.28) translate(-4.8656, -82.8539)",
    points: "4.51408499 82.5049193 5.21648885 82.5056438 5.21721334 83.2028015 4.51480948 83.202077"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.0777, 78.3122) rotate(172.28) translate(-15.0777, -78.3122)",
    points: "14.7651679 78.0020051 15.3896455 78.0026492 15.3902896 78.6224627 14.765812 78.6218186"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(14.274, 92.9547) rotate(172.28) translate(-14.274, -92.9547)",
    points: "13.9614106 92.6445016 14.5858882 92.6451458 14.5865323 93.2649592 13.9620547 93.2643151"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.8156, 73.912) rotate(172.28) translate(-15.8156, -73.912)",
    points: "15.581072 73.6791798 16.0496971 73.6796632 16.0501805 74.1447881 15.5815554 74.1443048"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(17.9981, 77.7621) rotate(172.28) translate(-17.9981, -77.7621)",
    points: "17.7635472 77.5293071 18.2321723 77.5297905 18.2326556 77.9949155 17.7640306 77.9944321"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(7.3902, 75.6723) rotate(172.28) translate(-7.3902, -75.6723)",
    points: "7.15566583 75.4394532 7.6242909 75.4399366 7.62477425 75.9050616 7.15614919 75.9045782"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.1971342,
    y1: 87.2234485,
    x2: 12.2640904,
    y2: 87.6842705,
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(15.2052, 66.5656) rotate(172.28) translate(-15.2052, -66.5656)",
    points: "14.9706792 66.3328453 15.4393043 66.3333286 15.4397877 66.7984536 14.9711626 66.7979703"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.383, 68.625) rotate(172.5191) translate(-11.383, -68.625)",
    points: "11.1487603 68.3925661 11.6166858 68.3930341 11.6171539 68.8574569 11.1492283 68.8569888"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(19.174, 69.0837) rotate(172.28) translate(-19.174, -69.0837)",
    points: "18.9394863 68.8509367 19.4081113 68.85142 19.4085947 69.316545 18.9399696 69.3160616"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(16.8735, 81.9407) rotate(172.28) translate(-16.8735, -81.9407)",
    points: "16.4434157 81.5137899 17.3027396 81.5146762 17.3036259 82.3675819 16.444302 82.3666956"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.0204, 83.5891) rotate(172.27) translate(-11.0204, -83.5891)",
    points: "10.7468762 83.3176321 11.2934274 83.3181965 11.2939918 83.8606659 10.7474407 83.8601015"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(4.0078, 87.8658) rotate(172.27) translate(-4.0078, -87.8658)",
    points: "3.73420798 87.5942385 4.28075911 87.594803 4.28132356 88.1372724 3.73477242 88.1367079"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(11.1822, 79.7742) rotate(172.28) translate(-11.1822, -79.7742)",
    points: "10.9476636 79.541432 11.4162886 79.5419154 11.416772 80.0070403 10.9481469 80.006557"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(7.2467, 83.2754) rotate(172.28) translate(-7.2467, -83.2754)",
    points: "7.01212233 83.0425483 7.4807474 83.0430317 7.48123076 83.5081566 7.01260569 83.5076733"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(1.7701, 90.6776) rotate(172.28) translate(-1.7701, -90.6776)",
    points: "1.41852628 90.3287033 2.12093014 90.3294277 2.12165463 91.0265854 1.41925077 91.025861"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(7.9719, 94.243) rotate(172.28) translate(-7.9719, -94.243)",
    points: "7.54179239 93.8160798 8.40111627 93.8169661 8.40200261 94.6698718 7.54267873 94.6689855"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(13.2211, 91.2065) rotate(172.28) translate(-13.2211, -91.2065)",
    points: "12.7910257 90.779591 13.6503495 90.7804774 13.6512359 91.6333831 12.791912 91.6324967"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.8251, 91.432) rotate(172.27) translate(-6.8251, -91.432)",
    points: "6.47349534 91.0830874 7.17589895 91.0838128 7.17662435 91.7809708 6.47422075 91.7802454"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(6.5855, 86.1206) rotate(172.28) translate(-6.5855, -86.1206)",
    points: "6.19490379 85.7329108 6.97523392 85.7337157 6.97603878 86.5082176 6.19570866 86.5074128"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(7.1519, 89.0174) rotate(172.28) translate(-7.1519, -89.0174)",
    points: "6.91737719 88.7845966 7.38600226 88.78508 7.38648562 89.2502049 6.91786055 89.2497216"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(13.7959, 83.332) rotate(172.28) translate(-13.7959, -83.332)",
    points: "13.5613446 83.0992056 14.0299696 83.099689 14.030453 83.5648139 13.5618279 83.5643306"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    transform: "translate(13.9247, 80.8134) rotate(172.28) translate(-13.9247, -80.8134)",
    points: "13.5341557 80.4257866 14.3144859 80.4265915 14.3152907 81.2010935 13.5349606 81.2002886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5516493,16.2632162 C20.7496265,9.01400936 30.1885639,15.1286406 32.2555001,18.8056824 C34.267987,15.0979192 43.6140404,8.84027417 50.9198485,15.9824855 C57.4793815,22.3947972 53.4127699,30.2732644 51.2860463,32.508516 L32.5021231,51.6077342 L13.4342097,32.7934841 C11.2733219,30.5900134 7.08927081,22.7719297 13.5516493,16.2632162 Z",
    id: "Path",
    fill: "#FF5C6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7517617,36.6993478 C20.7517617,36.6993478 20.7517617,36.7724437 20.7378825,36.91122 C20.7181042,37.1089668 20.6780383,37.3041944 20.6183077,37.4938685 C20.4805831,38.0044805 20.0578007,38.6877683 19.3040523,39.6931018 C18.0431785,41.3732482 17.5093623,43.2017052 17.8873042,45.2716965 C18.0869514,46.3670757 18.152077,47.6234777 18.4969222,48.6489391 C18.938922,49.9540718 20.5318295,49.7284279 21.2813074,48.8438615 C22.0307853,47.9592951 23.1368523,47.327916 23.0909442,46.1477879 C23.0290215,44.589468 21.5663652,43.3828559 21.4894957,41.8213579 C21.4371817,40.7047915 22.089505,39.5034762 22.1300751,39.4187273 C22.4407561,38.7968825 22.5240314,37.9896494 22.2090799,37.4705626 C21.8941283,36.9514757 21.3453653,36.705704 20.7517617,36.6993478 Z",
    id: "Path",
    fill: "#F7BDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3741946,37.9186723 C44.3741946,37.9186723 44.3677888,37.9907088 44.3571125,38.1305444 C44.3467125,38.3291382 44.3567288,38.5282667 44.3870062,38.7248459 C44.4478613,39.2492296 44.7628128,39.9886635 45.357484,41.093577 C46.3525173,42.9432211 46.6044786,44.8310023 45.9201263,46.8215415 C45.5581989,47.8745463 45.30517,49.1076424 44.808721,50.0716608 C44.1766827,51.296282 42.6350216,50.8375788 42.0264712,49.8523731 C41.4179207,48.8671674 40.4196845,48.0779435 40.6385491,46.9179433 C40.9342833,45.3861074 42.5602873,44.4093767 42.8677654,42.8764814 C43.0866301,41.7800428 42.62221,40.4960974 42.5923163,40.4049924 C42.3787898,39.7439511 42.4172246,38.9345994 42.8058428,38.4663619 C43.1944609,37.9981243 43.7869969,37.8360421 44.3741946,37.9186723 Z",
    id: "Path",
    fill: "#F7BDA4"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGivingHeart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/giving-heart.db85055102e69a90ce74c29f003520e4.svg";